import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetFundraisingApplicationList = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.fundraising.application_list],
    queryFn: () =>
      fundraisingService.applicationList().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Error fetching founder applications');
      }),
  });
};
